import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { ScrollTop } from 'primereact/scrolltop';
import { TabPanel, TabView } from 'primereact/tabview';
import { MidtermCouncil } from 'features/Council/pages';
import { MidtermDocumentsChecker, CreateContract } from 'features/SubmitProjectProposal/pages';
import Layout from 'layout';
import { LayoutProvider } from 'layout/context/layoutcontext';

import { AbilityContext } from 'components/Can';

function SubmitProjectProposalMidtermPage() {
  const { t } = useTranslation();
  // const { state } = useLocation();
  const navigate = useNavigate();
  const ability = useContext(AbilityContext);
  const [searchParams] = useSearchParams();
  const tab = searchParams.get('tab') || 0;

  return (
    <LayoutProvider>
      <Layout
        style={{
          maxHeight: 'calc(100vh - 9rem)',
          overflowY: 'auto',
          borderRadius: '12px',
          border: '1px solid var(--surface-border)',
          backgroundColor: 'white',
        }}
      >
        <>
          <TabView
            activeIndex={parseInt(tab, 10)}
            onTabChange={(e) => navigate(`.?tab=${e.index}`)}
          >
            {ability.can('read', 'project') && (
              <TabPanel header={t('contract.name')} leftIcon="pi pi-list mr-2">
                <CreateContract disabled/>
              </TabPanel>
            )}
            {ability.can('update', 'summary-report') && (
              <TabPanel
                header={t('projectProposal.viewList.midtermReport')}
                leftIcon="pi pi-list mr-2"
              >
                <MidtermDocumentsChecker />
              </TabPanel>
            )}
            {ability.can('read', 'council') && (
              <TabPanel
                header={t('projectProposal.viewList.midtermReview')}
                leftIcon="pi pi-list mr-2"
              >
                <MidtermCouncil />
              </TabPanel>
            )}
          </TabView>
          <ScrollTop target="parent" />
        </>
      </Layout>
    </LayoutProvider>
  );
}

export default SubmitProjectProposalMidtermPage;
